import { createFileRoute } from '@tanstack/react-router';
import { ComingSoon } from '@/features/placeholder/ComingSoon.tsx';

// Placeholder until this area is ported — see docs/features/*-alerts.md.
export const Route = createFileRoute('/_app/alerts')({
  component: AlertsPage,
});

function AlertsPage() {
  return <ComingSoon slug="alerts" />;
}
